import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || '';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');
  const [resendEmail, setResendEmail] = useState('');
  const [resending, setResending] = useState(false);
  const [resendMsg, setResendMsg] = useState('');

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    fetch(`${API_BASE}/api/auth/verify-email`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
      cache: 'no-store',
    })
      .then(async (res) => {
        if (!res.ok) {
          const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
          throw new Error(err.detail || `HTTP ${res.status}`);
        }
        setVerified(true);
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [token]);

  async function handleResend(e) {
    e.preventDefault();
    if (!resendEmail.trim()) return;
    setResending(true);
    setResendMsg('');
    try {
      const res = await fetch(`${API_BASE}/api/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resendEmail.trim() }),
        cache: 'no-store',
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
        throw new Error(err.detail || `HTTP ${res.status}`);
      }
      setResendMsg('Neuer Bestätigungslink wurde gesendet. Bitte prüfe dein Postfach.');
    } catch (err) {
      setResendMsg(`Fehler: ${err.message}`);
    } finally {
      setResending(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ background: 'var(--color-bg-content)' }}>
      <div className="card shadow-sm" style={{ width: '100%', maxWidth: 420 }}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <i className="bi bi-lightning-charge-fill text-warning fs-1" />
            <h4 className="mt-2 fw-bold">MK Workout</h4>
            <p className="text-muted small">E-Mail-Bestätigung</p>
          </div>

          {!token ? (
            <div className="text-center">
              <div className="alert alert-warning">
                <i className="bi bi-exclamation-triangle me-2" />
                Kein Bestätigungstoken gefunden.
              </div>
              <Link to="/login" className="btn btn-outline-secondary mt-2">
                <i className="bi bi-arrow-left me-1" />Zur Anmeldung
              </Link>
            </div>
          ) : loading ? (
            <div className="text-center py-4">
              <span className="spinner-border text-warning" />
              <p className="text-muted mt-3">E-Mail wird bestätigt...</p>
            </div>
          ) : verified ? (
            <div className="text-center">
              <div className="alert alert-success">
                <i className="bi bi-check-circle me-2" />
                Deine E-Mail-Adresse wurde erfolgreich bestätigt!
              </div>
              <p className="text-muted small">Du kannst dich jetzt anmelden.</p>
              <Link to="/login" className="btn btn-primary mt-2">
                <i className="bi bi-box-arrow-in-right me-1" />Jetzt anmelden
              </Link>
            </div>
          ) : (
            <div className="text-center">
              <div className="alert alert-danger">
                <i className="bi bi-x-circle me-2" />
                {error}
              </div>

              <p className="text-muted small mt-3">
                Neuen Bestätigungslink anfordern:
              </p>
              {resendMsg && (
                <div className="alert alert-info py-2 small">{resendMsg}</div>
              )}
              <form onSubmit={handleResend} className="mb-3">
                <div className="input-group input-group-sm">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="deine@email.de"
                    value={resendEmail}
                    onChange={(e) => setResendEmail(e.target.value)}
                    required
                  />
                  <button className="btn btn-outline-secondary" type="submit" disabled={resending}>
                    {resending ? (
                      <span className="spinner-border spinner-border-sm" />
                    ) : (
                      <><i className="bi bi-arrow-repeat me-1" />Senden</>
                    )}
                  </button>
                </div>
              </form>

              <Link to="/login" className="text-muted small">
                <i className="bi bi-arrow-left me-1" />Zur Anmeldung
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
